export function numTicksForWidth(width: number): number {
  if (width <= 300) {
    return 2;
  }
  if (300 < width && width <= 400) {
    return 5;
  }

  return 6;
}
